import startCase from "lodash/startCase";
import { STATUS } from "./ui";

const ON = "on";
const OFF = "off";

export const ON_OFF_SWITCH = {
  ON,
  OFF
};

export const getOnOffStatus = (val) =>
  val === ON_OFF_SWITCH.ON
    ? startCase(STATUS.ACTIVE)
    : startCase(STATUS.INACTIVE);

export const statusToOnOff = (status) =>
  status === STATUS.ACTIVE ? ON_OFF_SWITCH.ON : ON_OFF_SWITCH.OFF;
